import React, { useEffect, useRef, useState } from "react";
import GoogleMapReact, { Marker } from 'google-map-react';
import Gmarker from "./Gmarker";

const getMapViewPort = (map) => {
  const newBounds = map.getBounds();
  const vp = {
    zoom: map.getZoom(),
    center: {
      lat: map.getCenter().lat(),
      lng: map.getCenter().lng(),
    }, 
    bounds: {
      nw_lng: newBounds.getSouthWest().lng(),
      se_lat: newBounds.getSouthWest().lat(),
      se_lng: newBounds.getNorthEast().lng(),
      nw_lat: newBounds.getNorthEast().lat(),
    },
  };
  return vp;
}
const isInBounds = (bounds, { properties: { lat, lng } }) => {
  return (
    ((lng >= bounds.nw_lng &&
    lng <= bounds.se_lng ) || (lng <= bounds.nw_lng && lng >= bounds.se_lng)) &&
    ((lat >= bounds.nw_lat &&
      lat <= bounds.se_lat) || (lat <= bounds.nw_lat &&
        lat >= bounds.se_lat))
  );
};

const detectPointsInBounds = ({ bounds }, points) => {
  if (!bounds) return false;
  return points.find((point) => isInBounds(bounds, point));
};

const MapView = (props) => {
  const { results, hoveringItem, zoom = 8 } = props;
  const [vpChanged, setVpChanged] = useState(false)
  const mapRef = useRef(null);
  const defaultProps = {
    center: {
      lat: 13.7296581,
      lng: 100.5652847
    },
    zoom
  };
  const handleApiLoaded = (map, maps) => {
    // use map and maps objects
    mapRef.current = map;
    map.addListener("bounds_changed", () => {
      setVpChanged(true)
      // props.onChange(getMapViewPort(map))
    });    
   
  };
  const handleSearchVp = (e) => {
    e.preventDefault();
    props.onChange(getMapViewPort(mapRef.current))
    setVpChanged(false)
  }

  useEffect(() => {
    if(mapRef.current && results && results.length > 0) {
      const newPoints = results.map(({lat, lng}) => ({properties: {lat, lng}}))
      const mapViewPort = getMapViewPort(mapRef.current);
      const isInside = detectPointsInBounds(mapViewPort, newPoints);
      if(!isInside) {
        mapRef.current.panTo({
          lng: results[0].lng,
          lat: results[0].lat,
        });
      }
    }
  }, [results, mapRef])

  return (
    // Important! Always set the container height explicitly
    <div id="map">
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyAaegUMvmyVMyQeMClLJ6pm_gRsm65xXaQ" }}
        defaultCenter={defaultProps.center}
        defaultZoom={+defaultProps.zoom || 10}
        options={{
          mapTypeId: 'roadmap',
          zoomControl: true,
          mapTypeControl: true,
          scaleControl: false,
          panControl: true,
          navigationControl: false,
          utf_street_view_btnControl: false,
          gestureHandling: 'greedy',
        }}
        onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
      >
        {
          results.map((item) => (
            <Gmarker
              key={`rst-${item.slug}`}
              lat={item.lat}
              lng={item.lng}
              item={item}
              hoveringItem={hoveringItem}
            />
          ))
        }
       
      </GoogleMapReact>    
      {
        vpChanged && <a className="btn-search-location" href="#" onClick={handleSearchVp}>
        Search this location 
      </a> 
      }
     
    </div>
  );
}

export default MapView;